// Code generated by Prismic. DO NOT EDIT.

import Hero from "./Hero";

export const components = {
	hero: Hero
};